(() => {
  const OUT = 'translate(46%, -6px) rotate(7deg)';
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  function init(root) {
    const sheets = [...root.querySelectorAll('[data-sheet]')];
    const n = sheets.length;
    let order = sheets.slice();
    let busy = false;

    const place = (p) => `translate(${p * 7}px, ${-p * 2}px) rotate(${p * 2.5}deg)`;

    function layout() {
      order.forEach((sheet, p) => {
        sheet.style.zIndex = String(n - p);
        sheet.style.transform = place(p);
        sheet.setAttribute('aria-hidden', p ? 'true' : 'false');
        sheet.tabIndex = p ? -1 : 0;
      });
    }

    async function next() {
      if (busy || n < 2) return;
      busy = true;
      const front = order[0];
      order = [...order.slice(1), front];
      order.forEach((sheet, p) => {
        if (sheet === front) return;
        sheet.style.zIndex = String(n - p);
        sheet.style.transform = place(p);
        sheet.setAttribute('aria-hidden', p ? 'true' : 'false');
        sheet.tabIndex = p ? -1 : 0;
      });
      front.style.transform = OUT;
      await wait(150);
      front.style.zIndex = '0';
      front.style.transform = place(n - 1);
      front.setAttribute('aria-hidden', 'true');
      front.tabIndex = -1;
      await wait(150);
      busy = false;
    }

    async function prev() {
      if (busy || n < 2) return;
      busy = true;
      const last = order[n - 1];
      last.style.zIndex = String(n + 1);
      last.style.transform = OUT;
      await wait(130);
      order = [last, ...order.slice(0, -1)];
      layout();
      await wait(180);
      busy = false;
    }

    layout();
    if (n < 2) return;

    root.querySelector('[data-spec-next]')?.addEventListener('click', next);
    root.querySelector('[data-spec-prev]')?.addEventListener('click', prev);

    sheets.forEach((sheet) => {
      sheet.addEventListener('click', (event) => {
        if (order[0] !== sheet) {
          event.preventDefault();
          next();
        }
      });
    });

    let startX = null;
    let moved = false;
    root.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      moved = false;
    });
    root.addEventListener('pointermove', (event) => {
      if (startX !== null && Math.abs(event.clientX - startX) > 12) moved = true;
    });
    root.addEventListener('pointerup', (event) => {
      if (startX === null) return;
      const dx = event.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) dx < 0 ? next() : prev();
    });
    root.addEventListener(
      'click',
      (event) => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  const run = () => document.querySelectorAll('[data-spec-stack]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
